/**
 * The option sets the onboarding questions are drawn from.
 *
 * Kept apart from the step definitions because these are the lists most likely
 * to move — a new model ships, a craft gets a name — and moving one should not
 * mean touching the flow.
 */

export const SPECIALIZATIONS = [
  'AI Director',
  'AI Video Artist',
  'AI Cinematographer',
  'AI Editor',
  'AI VFX Artist',
  'Concept Artist',
  'Character Artist',
  'Environment Artist',
  'AI Producer',
  'Prompt Designer',
  'Storyboard Artist',
  'Motion Designer',
  'Compositor'
] as const;

export const AI_TOOLS = [
  'Veo',
  'Runway',
  'Kling',
  'Sora',
  'Luma',
  'Midjourney',
  'Flux',
  'Stable Diffusion',
  'ComfyUI',
  'Nano Banana',
  'ElevenLabs',
  'Suno',
  'Topaz',
  'Blender',
  'Unreal Engine',
  'After Effects',
  'DaVinci Resolve',
  'Nuke'
] as const;

export const PRODUCTION_SKILLS = [
  'Screenwriting',
  'Storyboarding',
  'Shot design',
  'Character consistency',
  'Lip sync & dialogue',
  'Colour grading',
  'Editing',
  'Sound design',
  'Music',
  'Compositing',
  'Rotoscoping',
  '3D & CGI',
  'Motion graphics',
  'Producing'
] as const;

export const INDUSTRIES = [
  'Film & episodic',
  'Advertising',
  'Music video',
  'Gaming',
  'Fashion & beauty',
  'Automotive',
  'FMCG & retail',
  'Real estate',
  'Education',
  'Corporate',
  'Sports',
  'Technology'
] as const;

export const LANGUAGES = [
  'English',
  'Hindi',
  'Tamil',
  'Telugu',
  'Malayalam',
  'Kannada',
  'Marathi',
  'Bengali',
  'Gujarati',
  'Punjabi',
  'Arabic',
  'Spanish',
  'French',
  'Japanese'
] as const;

export const PROJECT_TYPES = [
  'Short film',
  'Feature film',
  'Ad film / TVC',
  'Brand content',
  'Music video',
  'Explainer',
  'Product visualisation',
  'Character design',
  'Title sequence',
  'Social content'
] as const;

export const EXPERIENCE_BANDS = ['Under 1 year', '1–3 years', '3–5 years', '5–10 years', '10+ years'] as const;

export const AVAILABILITY = [
  'Open to work',
  'Open to selected projects',
  'Booked — future dates',
  'Not available'
] as const;

export const COMPANY_SIZES = ['1–10', '11–50', '51–200', '201–1000', '1000+'] as const;

export const COMPANY_NEEDS = [
  'AI Film Production',
  'AI Advertising',
  'AI Art',
  'AI Video',
  'AI VFX',
  'Character Design',
  'Product Visualization',
  'Other'
] as const;

export const BUDGET_BANDS = [
  'Under ₹50k',
  '₹50k – ₹2L',
  '₹2L – ₹10L',
  '₹10L – ₹50L',
  '₹50L+',
  'Discuss with professional'
] as const;

export const ACADEMY_TRACKS = [
  'AI Video Fundamentals',
  'AI Image Generation',
  'Prompting',
  'Character Consistency',
  'Storytelling',
  'AI Production',
  'Editing & Post',
  'Sound & Music'
] as const;

export const SKILL_LEVELS = ['Never tried it', 'Tinkered a bit', 'Made a few things', 'Fairly confident'] as const;

export const STUDY_YEARS = ['1st year', '2nd year', '3rd year', '4th year', 'Postgraduate', 'Recently graduated'] as const;

export const TIME_COMMITMENT = ['An hour a week', 'A few hours a week', 'Most evenings', 'Full time'] as const;

export const MAKE_INTERESTS = [
  'Short films',
  'Ads & brand films',
  'Music videos',
  'Anime & animation',
  'Character art',
  'Product shots',
  'Social clips',
  'Just exploring'
] as const;
